<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex xs12 sm6 md2>
            <v-text-field
              name="code"
              label="Product Code"
              type="text"
              class="mr-1"
              v-model="queryParams.code"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field
              name="name"
              label="Product Name"
              type="text"
              class="mr-1"
              v-model="queryParams.name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field
              name="brandName"
              label="Brand Name"
              type="text"
              class="mr-1"
              v-model="queryParams.brandName"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field
              name="categoryName"
              label="Category Name"
              type="text"
              class="mr-1"
              v-model="queryParams.categoryName"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field
              name="productGroupName"
              label="Product Group Name"
              type="text"
              class="mr-1"
              v-model="queryParams.productGroupName"
            ></v-text-field>
          </v-flex>
          <v-flex sm2>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-1">
          <v-data-table
            v-model="selectedProductList"
            :headers="headers"
            :items="productList"
            select-all
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <v-checkbox
                    primary
                    hide-details
                    @click.native="toggleAllProducts()"
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                  ></v-checkbox>
                </th>
                <th v-for="header in props.headers" :key="header.text">
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  primary
                  hide-details
                  :input-value="props.selected"
                  :value="props.item"
                  :indeterminate="props.indeterminate"
                  v-model="selectedProductList"
                  multiple
                ></v-checkbox>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.brand.name }}</td>
              <td>{{ props.item.category.name }}</td>
              <td v-if="props.item.productGroup">
                {{ props.item.productGroup.name }}
              </td>
              <td v-else></td>
              <td>{{ props.item.description }}</td>
            </template>
          </v-data-table>
          <div class="text-xs-right">
            <v-btn color="primary" @click="dialogClose">Ok</v-btn>
          </div>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
    
    
  <script>
import { productService } from "../../services/product-service";

export default {
  name: "MultiSelectProductListDialog",
  props: {
    showDialog: Boolean,
    params: Object,
  },

  data: () => ({
    showListLoading: false,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      stockWarehouseId: "",
      stockBinId: "",
      productType: "",
    },
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    rowsPerPageItems: [10, 50, 100],
    totalRows: 0,
    productList: [],
    selectedProductList: [],
  }),

  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
    isOpen: {
      handler() {
        if (this.isOpen) {

          this.queryParams = {
            ...this.params
          };
          this.selectedProductList = [];
          this.productList = [];
          this.getProductList();
        }
      },
    },
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    dialogClose() {
      this.$emit("close", this.selectedProductList);
    },
    toggleAllProducts() {
      if (this.selectedProductList.length) {
        this.selectedProductList = [];
      } else {
        this.selectedProductList = this.productList.slice();
      }
    },
  },
};
</script>
  